export default "__VITE_ASSET__ZNH3Q7Gn__"